module.exports = __webpack_public_path__ + "static/img/shopping.232bbd1d.svg";